/* eslint-disable*/
import { get } from 'lodash';
import { ListTable } from '../ListTable';
import { urls } from '@/Constants';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';

function GrnQcLogTable(props) {
	const { data, colMap, special, specialMappings, tableType, filters = {}, location = {}, exportRef } = props;
	const history = useHistory();

	const getTable = (tableType) => {
		switch (tableType) {
			case 'qualityChecks':
				return <ListTable
					colMap={colMap}
					actions={special}
					special={specialMappings}
					data={data}
					allowExport={false}
					showBtnContainer={false}
					headerColor={true}
					exportRef={exportRef}
				/>
			case 'machineScans':
				return <ListTable
					colMap={colMap}
					actions={special}
					special={specialMappings}
					data={data.map((obj, idx) => {
						const itemId = get(obj, ['itemId']);
						const id = get(obj, ['id']);
						return {
							...obj,
							onClick: () => {
								history.push({
									pathname: `${urls.EXTENSION}${urls.PAST_QC}/${itemId}`,
									search: `id=${id}`,
									state: {
										from: history?.location?.pathname,
									},
								});
							},
							styleCss: {
								cursor: 'pointer',
							}
						}
					})}
					allowExport={false}
					showBtnContainer={false}
					headerColor={true}
					exportRef={exportRef}
				/>
			case 'aiMachineQcLogs':
				return <ListTable
					colMap={colMap}
					actions={special}
					special={specialMappings}
					data={data.map((obj, idx) => {
						const itemId = get(obj, ['itemId']);
						const id = get(obj, ['id']);
						return {
							...obj,
							onClick: () => {
								history.push({
									pathname: `${urls.EXTENSION}${urls.PAST_QC}/${itemId}`,
									search: `id=${id}`,
									state: {
										from: history?.location?.pathname,
										search: history?.location?.search,
									},
								});
							},
							styleCss: {
								cursor: 'pointer',
							}
						}
					})}
					allowExport={false}
					showBtnContainer={false}
					exportRef={exportRef}
				/>
			case 'grnQcLogs':
			case 'productionQCLogs':
				return <ListTable
					colMap={colMap}
					actions={special}
					special={specialMappings}
					data={data.map((obj, idx) => {
						const id = get(obj, ['batchId']);
						return {
							...obj,
							// ...(!obj?.qualityCheckPresent ? {} : {
							onClick: () => {
								history.push({
									pathname: `${urls.EXTENSION}${urls.QUALITY_DETAILS}`,
									search: `id=${id}&tableType=${tableType}&parentTab=${tableType}`,
									state: {
										from: history?.location?.pathname,
										search: history?.location?.search,
									},
								});
							},
							// }),
							styleCss: {
								cursor: 'pointer',
							}
						}
					})}
					allowExport={false}
					showBtnContainer={false}
					exportRef={exportRef}
				/>

			default:
				return null;
		}
	}
	return getTable(tableType);
}
export default GrnQcLogTable;
